module.exports = __webpack_public_path__ + "img/C08TechVanisGripRM_ua.46fb59ef.webp";